"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemRendererCollapsed = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@floating-ui/react");
const FloatingUIWrapper_1 = require("./components/FloatingUIWrapper");
const SubMenu_1 = require("../../styled/SubMenu");
const MenuItemRendererCollapsed = ({ label, icon, children, isActive = false, onTrigger, testId, }) => {
    const hasChildren = react_1.Children.count(children) !== 0;
    const HeaderComponent = hasChildren ? SubMenu_1.Header : SubMenu_1.HeaderAlone;
    const isActiveProp = hasChildren
        ? react_1.Children.map(children, item => item?.props.isActive)?.some(Boolean)
        : isActive;
    return (
    // FloatingUIWrapper should handle all the events
    react_1.default.createElement(react_2.FloatingTree, null,
        react_1.default.createElement(FloatingUIWrapper_1.FloatingUIWrapper, { icon: icon, onClick: onTrigger, isActive: isActiveProp, header: react_1.default.createElement(HeaderComponent, null, label), testId: testId }, children)));
};
exports.MenuItemRendererCollapsed = MenuItemRendererCollapsed;
